export const DRIVER_TYPES = {
  Hook: "Hakowiec",
  Tir: "TIR",
};
